export const getPollenSchema = {
    'pollenIndex': 'pi',
    'cityName': 'cn',
    'state': 's',
    'techDiscussion': 'td',
    'techDiscussionToday': 'tdt',
    'predominantPollen': 'pp',
    'allergyFact': 'af',
    'pollenUrl': 'pl',
    'pollenMobileUrl': 'plm',
    'pollenMapUrl': 'pml',
    'pollenLabel': 'plbl'
};
